import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import {
  SimpleLoading,
  HeaderHLPure,
  ButtonAddHLPure,
  SearchBarHLPure,
  GridPure,
} from "../../pures";
import DialogDeleteDomainPure from "./../../pures/dialog-delete-domain/dialog-delete-domain-pure"

import "./configuration-domain.css";
import ConfigurationDomainsAddDomainView from "./configuration-domains-add.view";


const ConfigurationDomainsView = (props) => {
  let {
    domains,
    toggleDialogDeleteDomain,
    showDialogDeleteRequest,
    createDomain,
    editDomain,
    deleteDomain,
    setSelectedDomain,
    selectedDomain,
    action,
    setAction
  } = props

  const { t } = useTranslation();
  const { t: tCommon } = useTranslation('common');

  const [searchDominio, setSearchDominio] = useState('')

  const hideActions = useMediaQuery('(max-width: 820px)');

  const domainsGrid = useMemo(() => {
    if (!domains) return [];

    let copyDominios = [...domains]
    let newData = copyDominios.filter((dominio) => (
      dominio.name.toLowerCase().includes(searchDominio.toLowerCase()) ||
      dominio.name.includes(searchDominio.toLowerCase())))
    return newData
  }, [domains, searchDominio])

  const getHeaderTitle = () => {
    switch (action) {
      case t("configurationDomainView.newDomain"):
        return t("configurationDomainView.newDomain");
      case tCommon('details'):
        return t("configurationPanelView.detail.domain.title");
      default:
        return t("configurationDomainView.domains");
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [action]);

  const handleChangeSearch = (e) => setSearchDominio(e.target.value)

  const handleNewDomain = () => setAction(t("configurationDomainView.newDomain"));

  const handleDelete = (dataItem) => {
    toggleDialogDeleteDomain(true)
    setSelectedDomain(dataItem)
  }

  const handleViewDetails = (dataItem) => {
    setSelectedDomain(dataItem)
    setAction(tCommon('details'))
  }

  const handleBack = () => setAction(null)

  return (
    <>
      {showDialogDeleteRequest && (
        <DialogDeleteDomainPure
          selectedDomain={selectedDomain}
          toggleDialogDeleteDomain={toggleDialogDeleteDomain}
          deleteDomain={deleteDomain}
        />
      )}

      {props.loading
        ? <div className='loading'>
          <SimpleLoading />
        </div>
        : (
          <Container className="configurationDomainView">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <HeaderHLPure title={getHeaderTitle()} />
              </Grid>

              {action ? (
                <Grid item xs={12}>
                  <ConfigurationDomainsAddDomainView
                    backGrid={handleBack}
                    action={action}
                    createDomain={createDomain}
                    selectedDomain={selectedDomain}
                    editDomain={editDomain}
                    toggleDialogDeleteDomain={toggleDialogDeleteDomain}
                  />
                </Grid>
              ) : <>
                <Grid item xs={12} className="add-and-search-container">
                  <ButtonAddHLPure
                    iconAdd={true}
                    nameBtn={t("configurationDomainView.newDomain")}
                    onClickBtn={handleNewDomain}
                  />

                  <SearchBarHLPure
                    placeholder={t("configurationPanelView.placeholder.search")}
                    onSearchChange={((e) => handleChangeSearch(e))}
                  />
                </Grid>

                <Grid item xs={12}>
                  <GridPure
                    {...props}
                    className="configurationDomainView-grid"
                    dataGrid={domainsGrid}
                    skip={0}
                    take={6}
                    rowsItems={[{
                      field: 'name',
                      title: t("configurationDomainPanel.nameDomain"),
                      sorteable: true
                    },
                    {
                      field: 'email',
                      title: t("configurationPanelView.administrator.grid"),
                      sorteable: true
                    },
                    {
                      field: 'Acciones',
                      title: tCommon("actions"),
                      actions: true,
                      width: hideActions ? 60 : 200,
                      headerClassName: 'actionHeader'
                    }]}
                    actions={[
                      {
                        type: 'view-details',
                        value: tCommon('details'),
                        onClick: handleViewDetails
                      },
                      {
                        type: 'icon',
                        value: 'k-icon k-i-delete k-i-trash',
                        onClick: handleDelete
                      },
                    ]}
                  />
                </Grid>
              </>}
            </Grid>
          </Container>
        )}
    </>
  );
};

export { ConfigurationDomainsView as default };
